import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Chart } from 'chart.js';
import { Router } from '@angular/router';
import { NavService } from '../providers/nav.service';
import { ApiService } from '../providers/api.service';
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { ToastrService } from 'ngx-toastr';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { Subject } from 'rxjs';
import {Constants, MLBBatterToolTip, NBAToolTip, NFLToolTip, pageFilters, SharedService, sportList,platformList} from '../shared.service';
import { CommonService } from '../providers/common.service';
declare var $;

@Component({
  selector: 'app-manager',
  templateUrl: './manager.component.html',
  styleUrls: ['./manager.component.css']
})
export class ManagerComponent implements OnInit, OnDestroy {

  loginUserDetails: any = JSON.parse(localStorage.getItem('userDetails'));
  profileDet: any = {};
  selectedFilters: any = {
    sportId: '1',
    platformId: '2',
    typedisplay: '1',
    excludehighlow: '0',
    ha: '',
    Teams: '',
    Position: '',
    salaryRange: '0, 100000.00',
    categoryName: 'fantasy_points',
    limit: this.sharedService.defaultLimit,
    player_type: 'pitching',
  };
  loading = false;
  FiltersData: any = {};
  gameStyleList = [];
  categoryList = [];

  dataTableFilter: any = {
    firstselectbox: '5',
    secondselectbox: '10',
    thirdselectbox: '2019',
    fourthselectbox: '2018'
  };
  managerPlayerList: any;
  categoryFilter: any = 'fantasy_points';
  initialGameStyleId = '';
  showChildComponent = false;
  boardPlayerList: any = {};
  resetFilters = null;

  tableType = sportList[sportList.NFL];
  playerStatus = '';
  selectedPlayerForPopup: any = {};
  PopupLast5Position = '';
  popupLast5SalaryRange = '0, 100000.00';
  popUpLast5playerList = [];
  popupLast5TxtQueryChanged: Subject<string> = new Subject<string>();
  popupLast5SomeRange = [0, 100000.00];

  defualtPopupTab = 'Trends';
  popupTrendPlayerList: any = {};
  popupTrendfinalGraphData = {
    labels: [],
    datasets: []
  };
  popupTrendMyChart;

  isSideFilterShow = true;

  minValue = 0;
  maxValue = 100000.00;

  playerGameLogList = [];
  sportList = sportList;
  NFLToolTip = new NFLToolTip();
  NBAToolTip = new NBAToolTip();
  Constants = new Constants();
  MLBBatterToolTip = new MLBBatterToolTip();
  dropdownChanged =false;
  userDetail = JSON.parse(localStorage.getItem('userDetails'));
  constructor(
    private route: Router,
    private toastr: ToastrService,
    private api: ApiService,
    private SpinnerService: NgxSpinnerService,
    private changeDetectorRef: ChangeDetectorRef,
    private navService: NavService,
    public sharedService: SharedService,
    private commonService: CommonService,
  ) {
    if (this.loginUserDetails && this.loginUserDetails.userDetails) {
      this.profileDet = this.loginUserDetails.userDetails;
    }
    if (this.userDetail && this.userDetail.currentSport_id) {
      this.commonService.platformandsport.sport_id = this.userDetail.currentSport_id;
    }
    this.selectedFilters.platformId = this.commonService.platformandsport.platform_id.toString();
    this.selectedFilters.sportId = this.commonService.platformandsport.sport_id.toString();

    this.popupLast5TxtQueryChanged
      .pipe(debounceTime(1000), // wait 1 sec after the last event before emitting last event
        distinctUntilChanged()) // only emit if value is different from previous value
      .subscribe(model => {
        // console.log('range' + model);
        const range = model[0] + ',' + model[1];
        this.popupLast5SalaryRange = range;

        this.onLast5Popup();
      });
  }

  ngOnInit() {
    // var data = {
    //   labels: ['12/11', '12/8', '12/6', '12/4', '12/3', '12/1', '11/29', '11/27', '11/25', '11/23'],
    //   datasets: [{
    //     label: 'L. Dončić',
    //     fill: false,
    //     lineTension: '0',
    //     borderWidth: '2',
    //     backgroundColor: 'rgba(255,126,0)',
    //     borderColor: 'rgba(255,126,0)',
    //     pointBackgroundColor: 'rgba(255,126,0)',
    //     pointBorderColor: 'rgba(0,0,0)',
    //     pointBorderWidth: '1',
    //     data: [
    //       30.1, 25.5, 31.6, 32.5, 26.2, 35.2, 40.5, 21.3, 37.6, 35.2
    //     ]
    //   }, {
    //     label: 'N. Jokić',
    //     fill: false,
    //     lineTension: '0',
    //     borderWidth: '2',
    //     backgroundColor: 'rgba(0,100,246)',
    //     borderColor: 'rgba(0,100,246)',
    //     pointBackgroundColor: 'rgba(0,100,246)',
    //     pointBorderColor: 'rgba(0,0,0)',
    //     pointBorderWidth: '1',
    //     data: [
    //       37.6, 39.5, 35.8, 33.5, 28.3, 32.4, 38.1, 32.0, 39.4, 35.1
    //     ],
    //   }, {
    //     label: 'All Players',
    //     fill: false,
    //     lineTension: '0',
    //     borderWidth: '2',
    //     backgroundColor: 'rgba(209,0,222)',
    //     borderColor: 'rgba(209,0,222)',
    //     pointBackgroundColor: 'rgba(209,0,222)',
    //     pointBorderColor: 'rgba(0,0,0)',
    //     pointBorderWidth: '1',
    //     data: [
    //       40.6, 23.0, 24.7, 31.7, 29.7, 30.3, 21.3, 30.0, 34.8, 32.5
    //     ],
    //   }]
    // };


    // var ctx = document.getElementById('myChart');
    // var myChart = new Chart(ctx, {
    //   type: 'line',
    //   data: data,
    //   options: {
    //     responsive: true,
    //     title: {
    //       display: false
    //     },
    //     tooltips: {
    //       mode: 'index',
    //       intersect: false,
    //     },
    //     hover: {
    //       mode: 'nearest',
    //       intersect: true
    //     },
    //     scales: {
    //       xAxes: [{
    //         display: true,
    //         scaleLabel: {
    //           display: false,
    //           labelString: 'Games'
    //         }
    //       }],
    //       yAxes: [{
    //         display: true,
    //         scaleLabel: {
    //           display: false,
    //           labelString: 'Usage %'
    //         }
    //       }]
    //     }
    //   }
    // });


    this.defualtFilters();
  }

  defualtFilters() {
    const filtersObj = {
      platform_id: this.selectedFilters.platformId,
      sport_id: this.selectedFilters.sportId,
      user_id: (this.loginUserDetails && this.loginUserDetails.user_id) ? this.loginUserDetails.user_id : '',
    };
    this.loading = true;
    this.SpinnerService.show();
    this.api.boardInitialLoadData(filtersObj).subscribe(data => {
      this.SpinnerService.hide();
      this.loading = false;
      if (data && data.code) {
        this.gameStyleList = data.data.gameStyleList;
        this.FiltersData = data.data;
        this.categoryList = data.data.categoryList;
        this.selectedFilters.slate = '';
        if(this.userDetail.fieldType !== undefined){
          this.selectedFilters.player_type =  this.userDetail.fieldType;
        }else{
          this.selectedFilters.player_type = this.selectedFilters.player_type ? this.selectedFilters.player_type : 'pitching';
        }
        this.initialGameStyleId = '';

        if (this.FiltersData && this.FiltersData.gameStyleList && this.FiltersData.gameStyleList.length > 0) {
          var classicObj = this.FiltersData.gameStyleList.find(x=>(x.game_style_name.toLowerCase() == 'classic' || x.game_style_name.toLowerCase() == 'full roster'));
          this.initialGameStyleId = classicObj ? classicObj.game_style_id : this.FiltersData.gameStyleList[0].game_style_id;
          // this.selectedFilters.slate = this.initialGameStyleId;

         /* this.FiltersData.gameStyleList.forEach(element => {
            if (this.initialGameStyleId == element.game_style_id && element.slates && element.slates.length > 0) {
              this.selectedFilters.slate = element.slates[0].slates_id;

            }
          });*/
          let data = this.FiltersData.gameStyleList.filter(element => this.initialGameStyleId == element.game_style_id && element.slates && element.slates.length > 0);
          if (data.length > 0) {
            if (this.commonService.platformandsport.platform_id == platformList.DraftKings) {
              const blankSlates = data[0].slates.filter(({slates_label}) => slates_label === "" || slates_label === null);
              const withoutBlankSlates = data[0].slates.filter(({slates_label}) => slates_label !== "" && slates_label !== null);
              this.selectedFilters.slate = [...blankSlates, ...withoutBlankSlates][0].slates_id;

            }
            if (this.commonService.platformandsport.platform_id == platformList.FanDuel) {
              const blankSlates = data[0].slates.filter(({slates_label}) => slates_label === "Main" || slates_label === null);
              const withoutBlankSlates = data[0].slates.filter(({slates_label}) => slates_label !== "Main" && slates_label !== null);
              this.selectedFilters.slate = [...blankSlates, ...withoutBlankSlates][0].slates_id;
            }

            // if (type == 'DefaultSelectedSlate') {
            // this.filters.slate = this.slate[0].slates_id;
            // }
          }
          /*OVERWRITE LOCAL STORAGE SLATES*/
          if (localStorage.getItem('uselocalStorage') && localStorage.getItem('uselocalStorage') == 'yes') {
            this.selectedFilters.slate = JSON.parse(localStorage.getItem('userDetails')).slateSelection ? JSON.parse(localStorage.getItem('userDetails')).slateSelection.slate : this.FiltersData.gameStyleList.filter(element => this.initialGameStyleId == element.game_style_id && element.slates && element.slates.length > 0)[0].slates[0].slates_id;
          }
        }
        this.showChild();
        this.PlayerList();

        // console.log('Data loaded successfully');
      } else {
        // console.log('Somthing went wrong');
      }
    }, (err) => {
      this.SpinnerService.hide();
      this.loading = false;
      // console.log('Somthing went wrong');
    });
  }


  showChild() {
    if (this.showChildComponent) {
      this.showChildComponent = false;
    }
    this.changeDetectorRef.detectChanges();

    this.showChildComponent = true;
  }

  PlayerList() {
    $('#managerTable').DataTable().clear().destroy();
    if (this.selectedFilters.sportId == sportList.NFL) {
      this.tableType = sportList[sportList.NFL];
    } else if (this.selectedFilters.sportId == sportList.NBA) {
      this.tableType = sportList[sportList.NBA];
    } else if (this.selectedFilters.sportId == sportList.MLB) {
      this.tableType = sportList[sportList.MLB];
    }

    // const cat_cols =
    // {
    //   category_columns: [
    //     { key: 'game', value: this.dataTableFilter.firstselectbox, name: 'gm' + this.dataTableFilter.firstselectbox },
    //     { key: 'game', value: this.dataTableFilter.secondselectbox, name: 'gm' + this.dataTableFilter.secondselectbox },
    //     { key: 'season', value: this.dataTableFilter.thirdselectbox, name: 'season' + this.dataTableFilter.thirdselectbox },
    //     { key: 'season', value: this.dataTableFilter.fourthselectbox, name: 'season' + this.dataTableFilter.fourthselectbox },
    //   ]
    // }
    const boardPlayersFiltersData = {
      user_id: (this.loginUserDetails && this.loginUserDetails.user_id) ? this.loginUserDetails.user_id : '',
      sport_id: this.selectedFilters.sportId,
      // slates_id: '239', //need to ask
      slates_id: this.selectedFilters.slate.toString(),
      position: (this.selectedFilters.Position == null) ? '' : this.selectedFilters.Position,
      team: (this.selectedFilters.Teams == null) ? '' : this.selectedFilters.Teams,
      ha: this.selectedFilters.ha,
      salary_range: this.dropdownChanged ? "0, 100000.00" : this.selectedFilters.salaryRange,
      // category_name: this.categoryFilter,
      // category_columns: JSON.stringify(cat_cols),
      platform_id: this.selectedFilters.platformId,
      exclude_high_low: this.selectedFilters.excludehighlow,
      type_display: this.selectedFilters.typedisplay,
      player_type: this.selectedFilters.player_type ? this.selectedFilters.player_type : '',
      page_type: 'manager',
    };
    this.managerPlayerList = [];

    this.SpinnerService.show();
    this.api.playerList(boardPlayersFiltersData).subscribe((item) => {
      this.SpinnerService.hide();
      this.dropdownChanged =false;
      if (item && item.code == 100) {
        if (item.data.listPlayer && item.data.listPlayer.length > 0) {
          if (this.tableType == sportList[sportList.NFL]) {
            this.setNFLColor(item);
          }

          if (this.tableType == sportList[sportList.NBA]) {
            this.setNBAColor(item);
          }
          if (this.tableType == sportList[sportList.MLB]) {
            this.setMLBColor(item);
          }
        }

        this.managerPlayerList = item.data.listPlayer;
        item.data.gameStyleList = this.gameStyleList;
        this.FiltersData = item.data;
        if (item.data && item.data.salaryRange){
          this.selectedFilters.salaryRange = item.data.salaryRange[0].min_salary+', '+item.data.salaryRange[0].max_salary;
        }
        this.setDatatable();
      } else {
        this.setDatatable();
      }
    }, (err) => {
      this.SpinnerService.hide();
      this.setDatatable();
    });
  }

  getColorReverseCondition(d, type = null) {
    if (this.selectedFilters.typedisplay != 1 && type == null && type != 'rank') {
      return !d;
    }
    return d;
  }

  setNFLColor(item) {
    item.data.listPlayer.forEach(element => {
      element.category.vegas_odds.odds_implied_team_total_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.vegas_odds.odds_implied_team_total, key: 'element.category.vegas_odds.odds_implied_team_total', sport: 'NFL' }, this.getColorReverseCondition(false));
      element.category.vegas_odds.odds_spread_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.vegas_odds.odds_spread, key: 'element.category.vegas_odds.odds_spread', sport: 'NFL'  }, this.getColorReverseCondition(true));
      element.category.vegas_odds.odds_ou_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.vegas_odds.odds_ou, key: 'element.category.vegas_odds.odds_ou' , sport: 'NFL' }, this.getColorReverseCondition(false));

      if (element.category.fantasy_points) {
        element.category.fantasy_points.PrevGm_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.fantasy_points.PrevGm, key: 'element.category.fantasy_points.PrevGm' , sport: 'NFL' }, this.getColorReverseCondition(false));
        element.category.fantasy_points.gm3_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.fantasy_points.gm3, key: 'element.category.fantasy_points.gm3', sport: 'NFL'  }, this.getColorReverseCondition(false));
        element.category.fantasy_points.gm5_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.fantasy_points.gm5, key: 'element.category.fantasy_points.gm5', sport: 'NFL'  }, this.getColorReverseCondition(false));
        element.category.fantasy_points.season2020_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.fantasy_points.season2020, key: 'element.category.fantasy_points.season2020', sport: 'NFL'  }, this.getColorReverseCondition(false));
      }


      if (element.category.fantasy_value) {
        element.category.fantasy_value.PrevGm_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.fantasy_value.PrevGm, key: 'element.category.fantasy_value.PrevGm', sport: 'NFL'  }, this.getColorReverseCondition(false));
        element.category.fantasy_value.gm3_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.fantasy_value.gm3, key: 'element.category.fantasy_value.gm3', sport: 'NFL' }, this.getColorReverseCondition(false));
        element.category.fantasy_value.gm5_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.fantasy_value.gm5, key: 'element.category.fantasy_value.gm5', sport: 'NFL' }, this.getColorReverseCondition(false));
        element.category.fantasy_value.season2020_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.fantasy_value.season2020, key: 'element.category.fantasy_value.season2020', sport: 'NFL'  }, this.getColorReverseCondition(false));
      }

      element.category.high_score.gm3_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.high_score.gm3, key: 'element.category.high_score.gm3', sport: 'NFL'  }, this.getColorReverseCondition(false));
      element.category.high_score.gm5_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.high_score.gm5, key: 'element.category.high_score.gm5', sport: 'NFL'  }, this.getColorReverseCondition(false));
      element.category.high_score.season2020_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.high_score.season2020, key: 'element.category.high_score.season2020' , sport: 'NFL' }, this.getColorReverseCondition(false));

      element.category.low_score.gm3_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.low_score.gm3, key: 'element.category.low_score.gm3' , sport: 'NFL' }, this.getColorReverseCondition(false));
      element.category.low_score.gm5_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.low_score.gm5, key: 'element.category.low_score.gm5' , sport: 'NFL' }, this.getColorReverseCondition(false));
      element.category.low_score.season2020_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.low_score.season2020, key: 'element.category.low_score.season2020', sport: 'NFL'  }, this.getColorReverseCondition(false));

      element.category.off_snap.PrevGm_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.off_snap.PrevGm, key: 'element.category.off_snap.PrevGm' , sport: 'NFL' }, this.getColorReverseCondition(false));
      element.category.off_snap.gm3_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.off_snap.gm3, key: 'element.category.off_snap.gm3', sport: 'NFL'  }, this.getColorReverseCondition(false));
      element.category.off_snap.gm5_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.off_snap.gm5, key: 'element.category.off_snap.gm5', sport: 'NFL'  }, this.getColorReverseCondition(false));
      element.category.off_snap.season2020_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.off_snap.season2020, key: 'element.category.off_snap.season2020', sport: 'NFL'  }, this.getColorReverseCondition(false));

      element.category.pass_yds.PrevGm_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.pass_yds.PrevGm, key: 'element.category.pass_yds.PrevGm', sport: 'NFL'  }, this.getColorReverseCondition(false));
      element.category.pass_yds.gm3_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.pass_yds.gm3, key: 'element.category.pass_yds.gm3', sport: 'NFL' }, this.getColorReverseCondition(false));
      element.category.pass_yds.gm5_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.pass_yds.gm5, key: 'element.category.pass_yds.gm5', sport: 'NFL' }, this.getColorReverseCondition(false));
      element.category.pass_yds.season2020_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.pass_yds.season2020, key: 'element.category.pass_yds.season2020', sport: 'NFL'  }, this.getColorReverseCondition(false));

      element.category.pass_td.PrevGm_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.pass_td.PrevGm, key: 'element.category.pass_td.PrevGm' , sport: 'NFL' }, this.getColorReverseCondition(false));
      element.category.pass_td.gm3_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.pass_td.gm3, key: 'element.category.pass_td.gm3' , sport: 'NFL' }, this.getColorReverseCondition(false));
      element.category.pass_td.gm5_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.pass_td.gm5, key: 'element.category.pass_td.gm5' , sport: 'NFL' }, this.getColorReverseCondition(false));
      element.category.pass_td.season2020_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.pass_td.season2020, key: 'element.category.pass_td.season2020' , sport: 'NFL' }, this.getColorReverseCondition(false));

      element.category.qr_rating.PrevGm_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.qr_rating.PrevGm, key: 'element.category.qr_rating.PrevGm', sport: 'NFL'  }, this.getColorReverseCondition(false));
      element.category.qr_rating.gm3_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.qr_rating.gm3, key: 'element.category.qr_rating.gm3', sport: 'NFL' }, this.getColorReverseCondition(false));
      element.category.qr_rating.gm5_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.qr_rating.gm5, key: 'element.category.qr_rating.gm5', sport: 'NFL' }, this.getColorReverseCondition(false));
      element.category.qr_rating.season2020_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.qr_rating.season2020, key: 'element.category.qr_rating.season2020', sport: 'NFL'  }, this.getColorReverseCondition(false));

      element.category.rush_att.PrevGm_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.rush_att.PrevGm, key: 'element.category.rush_att.PrevGm', sport: 'NFL'  }, this.getColorReverseCondition(false));
      element.category.rush_att.gm3_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.rush_att.gm3, key: 'element.category.rush_att.gm3', sport: 'NFL' }, this.getColorReverseCondition(false));
      element.category.rush_att.gm5_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.rush_att.gm5, key: 'element.category.rush_att.gm5', sport: 'NFL' }, this.getColorReverseCondition(false));
      element.category.rush_att.season2020_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.rush_att.season2020, key: 'element.category.rush_att.season2020', sport: 'NFL'  }, this.getColorReverseCondition(false));

      element.category.rush_yds.PrevGm_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.rush_yds.PrevGm, key: 'element.category.rush_yds.PrevGm' , sport: 'NFL' }, this.getColorReverseCondition(false));
      element.category.rush_yds.gm3_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.rush_yds.gm3, key: 'element.category.rush_yds.gm3' , sport: 'NFL' }, this.getColorReverseCondition(false));
      element.category.rush_yds.gm5_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.rush_yds.gm5, key: 'element.category.rush_yds.gm5' , sport: 'NFL' }, this.getColorReverseCondition(false));
      element.category.rush_yds.season2020_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.rush_yds.season2020, key: 'element.category.rush_yds.season2020', sport: 'NFL'  }, this.getColorReverseCondition(false));

      element.category.rush_td.PrevGm_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.rush_td.PrevGm, key: 'element.category.rush_td.PrevGm', sport: 'NFL'  }, this.getColorReverseCondition(false));
      element.category.rush_td.gm3_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.rush_td.gm3, key: 'element.category.rush_td.gm3' , sport: 'NFL' }, this.getColorReverseCondition(false));
      element.category.rush_td.gm5_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.rush_td.gm5, key: 'element.category.rush_td.gm5' , sport: 'NFL' }, this.getColorReverseCondition(false));
      element.category.rush_td.season2020_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.rush_td.season2020, key: 'element.category.rush_td.season2020', sport: 'NFL'  }, this.getColorReverseCondition(false));

      element.category.tgts.PrevGm_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.tgts.PrevGm, key: 'element.category.tgts.PrevGm' , sport: 'NFL' }, this.getColorReverseCondition(false));
      element.category.tgts.gm3_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.tgts.gm3, key: 'element.category.tgts.gm3', sport: 'NFL' }, this.getColorReverseCondition(false));
      element.category.tgts.gm5_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.tgts.gm5, key: 'element.category.tgts.gm5', sport: 'NFL' }, this.getColorReverseCondition(false));
      element.category.tgts.season2020_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.tgts.season2020, key: 'element.category.tgts.season2020', sport: 'NFL'  }, this.getColorReverseCondition(false));

      element.category.rec.PrevGm_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.rec.PrevGm, key: 'element.category.rec.PrevGm', sport: 'NFL'  }, this.getColorReverseCondition(false));
      element.category.rec.gm3_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.rec.gm3, key: 'element.category.rec.gm3', sport: 'NFL'  }, this.getColorReverseCondition(false));
      element.category.rec.gm5_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.rec.gm5, key: 'element.category.rec.gm5', sport: 'NFL'  }, this.getColorReverseCondition(false));
      element.category.rec.season2020_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.rec.season2020, key: 'element.category.rec.season2020', sport: 'NFL'  }, this.getColorReverseCondition(false));

      element.category.rec_yds.PrevGm_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.rec_yds.PrevGm, key: 'element.category.rec_yds.PrevGm', sport: 'NFL'  }, this.getColorReverseCondition(false));
      element.category.rec_yds.gm3_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.rec_yds.gm3, key: 'element.category.rec_yds.gm3', sport: 'NFL'  }, this.getColorReverseCondition(false));
      element.category.rec_yds.gm5_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.rec_yds.gm5, key: 'element.category.rec_yds.gm5', sport: 'NFL'  }, this.getColorReverseCondition(false));
      element.category.rec_yds.season2020_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.rec_yds.season2020, key: 'element.category.rec_yds.season2020', sport: 'NFL'  }, this.getColorReverseCondition(false));

      element.category.rec_td.PrevGm_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.rec_td.PrevGm, key: 'element.category.rec_td.PrevGm' , sport: 'NFL' }, this.getColorReverseCondition(false));
      element.category.rec_td.gm3_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.rec_td.gm3, key: 'element.category.rec_td.gm3' , sport: 'NFL' }, this.getColorReverseCondition(false));
      element.category.rec_td.gm5_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.rec_td.gm5, key: 'element.category.rec_td.gm5' , sport: 'NFL' }, this.getColorReverseCondition(false));
      element.category.rec_td.season2020_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.rec_td.season2020, key: 'element.category.rec_td.season2020', sport: 'NFL'  }, this.getColorReverseCondition(false));

      element.scoring_team_rank_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.scoring_team_rank, key: 'element.scoring_team_rank', sport: 'NFL' , type: 'rank'  }, this.getColorReverseCondition(true, 'rank'));
      element.scoring_opp_team_rank_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.scoring_opp_team_rank, key: 'element.scoring_opp_team_rank' , sport: 'NFL' , type: 'rank' }, this.getColorReverseCondition(false, 'rank'));

      element.pass_yds_team_rank_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.pass_yds_team_rank, key: 'element.pass_yds_team_rank' , sport: 'NFL', type: 'rank' }, this.getColorReverseCondition(true, 'rank'));
      element.pass_yds_opp_team_rank_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.pass_yds_opp_team_rank, key: 'element.pass_yds_opp_team_rank', sport: 'NFL', type: 'rank'  }, this.getColorReverseCondition(false, 'rank'));

      element.rush_yds_team_rank_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.rush_yds_team_rank, key: 'element.rush_yds_team_rank', sport: 'NFL', type: 'rank'  }, this.getColorReverseCondition(true, 'rank'));
      element.rush_yds_opp_team_rank_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.rush_yds_opp_team_rank, key: 'element.rush_yds_opp_team_rank', sport: 'NFL' , type: 'rank' }, this.getColorReverseCondition(false, 'rank'));

      element.plays_per_game_team_rank_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.plays_per_game_team_rank, key: 'element.plays_per_game_team_rank', sport: 'NFL' , type: 'rank' }, this.getColorReverseCondition(true, 'rank'));
      element.plays_per_game_opp_team_rank_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.plays_per_game_opp_team_rank, key: 'element.plays_per_game_opp_team_rank', sport: 'NFL' , type: 'rank' }, this.getColorReverseCondition(false, 'rank'));

      element.red_zone_team_rank_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.red_zone_team_rank, key: 'element.red_zone_team_rank' , sport: 'NFL' , type: 'rank' }, this.getColorReverseCondition(true, 'rank'));
      element.red_zone_opp_team_rank_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.red_zone_opp_team_rank, key: 'element.red_zone_opp_team_rank', sport: 'NFL' , type: 'rank'  }, this.getColorReverseCondition(false, 'rank'));

      element.third_down_conv_team_rank_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.third_down_conv_team_rank, key: 'element.third_down_conv_team_rank' , sport: 'NFL'  , type: 'rank'}, this.getColorReverseCondition(true, 'rank'));
      element.third_down_conv_opp_team_rank_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.third_down_conv_opp_team_rank, key: 'element.third_down_conv_opp_team_rank', sport: 'NFL'  , type: 'rank' }, this.getColorReverseCondition(false, 'rank'));
    });
  }

  setNBAColor(item) {
    item.data.listPlayer.forEach(element => {
      element.category.vegas_odds.odds_implied_team_total_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.vegas_odds.odds_implied_team_total, key: 'element.category.vegas_odds.odds_implied_team_total', sport: 'NBA' }, this.getColorReverseCondition(false));
      element.category.vegas_odds.odds_spread_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.vegas_odds.odds_spread, key: 'element.category.vegas_odds.odds_spread', sport: 'NBA'  }, this.getColorReverseCondition(true));
      element.category.vegas_odds.odds_ou_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.vegas_odds.odds_ou, key: 'element.category.vegas_odds.odds_ou', sport: 'NBA'  }, this.getColorReverseCondition(false));

      if (element.category.fantasy_points) {
        element.category.fantasy_points.PrevGm_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.fantasy_points.PrevGm, key: 'element.category.fantasy_points.PrevGm', sport: 'NBA'  }, this.getColorReverseCondition(false));
        element.category.fantasy_points.gm3_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.fantasy_points.gm3, key: 'element.category.fantasy_points.gm3', sport: 'NBA'  }, this.getColorReverseCondition(false));
        element.category.fantasy_points.gm5_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.fantasy_points.gm5, key: 'element.category.fantasy_points.gm5', sport: 'NBA'  }, this.getColorReverseCondition(false));
        element.category.fantasy_points.season2020_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.fantasy_points.season2020, key: 'element.category.fantasy_points.season2020' , sport: 'NBA' }, this.getColorReverseCondition(false));
      }

      if (element.category.fantasy_value) {
        element.category.fantasy_value.PrevGm_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.fantasy_value.PrevGm, key: 'element.category.fantasy_value.PrevGm', sport: 'NBA'  }, this.getColorReverseCondition(false));
        element.category.fantasy_value.gm3_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.fantasy_value.gm3, key: 'element.category.fantasy_value.gm3' , sport: 'NBA' }, this.getColorReverseCondition(false));
        element.category.fantasy_value.gm5_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.fantasy_value.gm5, key: 'element.category.fantasy_value.gm5', sport: 'NBA'  }, this.getColorReverseCondition(false));
        element.category.fantasy_value.season2020_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.fantasy_value.season2020, key: 'element.category.fantasy_value.season2020', sport: 'NBA'  }, this.getColorReverseCondition(false));
      }


      element.category.high_score.gm3_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.high_score.gm3, key: 'element.category.high_score.gm3' , sport: 'NBA' }, this.getColorReverseCondition(false));
      element.category.high_score.gm5_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.high_score.gm5, key: 'element.category.high_score.gm5', sport: 'NBA'  }, this.getColorReverseCondition(false));
      element.category.high_score.season2020_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.high_score.season2020, key: 'element.category.high_score.season2020', sport: 'NBA'  }, this.getColorReverseCondition(false));

      element.category.low_score.gm3_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.low_score.gm3, key: 'element.category.low_score.gm3', sport: 'NBA'  }, this.getColorReverseCondition(false));
      element.category.low_score.gm5_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.low_score.gm5, key: 'element.category.low_score.gm5', sport: 'NBA' }, this.getColorReverseCondition(false));
      element.category.low_score.season2020_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.low_score.season2020, key: 'element.category.low_score.season2020', sport: 'NBA'  }, this.getColorReverseCondition(false));

      element.category.min.PrevGm_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.min.PrevGm, key: 'element.category.min.PrevGm', sport: 'NBA'  }, this.getColorReverseCondition(false));
      element.category.min.gm3_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.min.gm3, key: 'element.category.min.gm3', sport: 'NBA'  }, this.getColorReverseCondition(false));
      element.category.min.gm5_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.min.gm5, key: 'element.category.min.gm5', sport: 'NBA'  }, this.getColorReverseCondition(false));
      element.category.min.season2020_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.min.season2020, key: 'element.category.min.season2020', sport: 'NBA'  }, this.getColorReverseCondition(false));

      if (element.category.fantasy_points_per_min) {
        element.category.fantasy_points_per_min.PrevGm_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.fantasy_points_per_min.PrevGm, key: 'element.category.fantasy_points_per_min.PrevGm' , sport: 'NBA' }, this.getColorReverseCondition(false));
        element.category.fantasy_points_per_min.gm3_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.fantasy_points_per_min.gm3, key: 'element.category.fantasy_points_per_min.gm3', sport: 'NBA'  }, this.getColorReverseCondition(false));
        element.category.fantasy_points_per_min.gm5_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.fantasy_points_per_min.gm5, key: 'element.category.fantasy_points_per_min.gm5', sport: 'NBA'  }, this.getColorReverseCondition(false));
        element.category.fantasy_points_per_min.season2020_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.fantasy_points_per_min.season2020, key: 'element.category.fantasy_points_per_min.season2020', sport: 'NBA'  }, this.getColorReverseCondition(false));
      }


      element.category.usage.PrevGm_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.usage.PrevGm, key: 'element.category.usage.PrevGm', sport: 'NBA'  }, this.getColorReverseCondition(false));
      element.category.usage.gm3_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.usage.gm3, key: 'element.category.usage.gm3' , sport: 'NBA' }, this.getColorReverseCondition(false));
      element.category.usage.gm5_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.usage.gm5, key: 'element.category.usage.gm5', sport: 'NBA'  }, this.getColorReverseCondition(false));
      element.category.usage.season2020_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.usage.season2020, key: 'element.category.usage.season2020', sport: 'NBA' }, this.getColorReverseCondition(false));

      element.category.pts.PrevGm_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.pts.PrevGm, key: 'element.category.pts.PrevGm' , sport: 'NBA' }, this.getColorReverseCondition(false));
      element.category.pts.gm3_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.pts.gm3, key: 'element.category.pts.gm3' , sport: 'NBA' }, this.getColorReverseCondition(false));
      element.category.pts.gm5_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.pts.gm5, key: 'element.category.pts.gm5' , sport: 'NBA' }, this.getColorReverseCondition(false));
      element.category.pts.season2020_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.pts.season2020, key: 'element.category.pts.season2020' , sport: 'NBA' }, this.getColorReverseCondition(false));

      element.category.fg.PrevGm_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.fg.PrevGm, key: 'element.category.fg.PrevGm' , sport: 'NBA' }, this.getColorReverseCondition(false));
      element.category.fg.gm3_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.fg.gm3, key: 'element.category.fg.gm3' , sport: 'NBA' }, this.getColorReverseCondition(false));
      element.category.fg.gm5_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.fg.gm5, key: 'element.category.fg.gm5' , sport: 'NBA' }, this.getColorReverseCondition(false));
      element.category.fg.season2020_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.fg.season2020, key: 'element.category.fg.season2020' , sport: 'NBA' }, this.getColorReverseCondition(false));

      element.category.fga.PrevGm_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.fga.PrevGm, key: 'element.category.fga.PrevGm' , sport: 'NBA' }, this.getColorReverseCondition(false));
      element.category.fga.gm3_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.fga.gm3, key: 'element.category.fga.gm3' , sport: 'NBA' }, this.getColorReverseCondition(false));
      element.category.fga.gm5_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.fga.gm5, key: 'element.category.fga.gm5' , sport: 'NBA' }, this.getColorReverseCondition(false));
      element.category.fga.season2020_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.fga.season2020, key: 'element.category.fga.season2020' , sport: 'NBA' }, this.getColorReverseCondition(false));

      element.category.fgp.PrevGm_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.fgp.PrevGm, key: 'element.category.fgp.PrevGm' , sport: 'NBA' }, this.getColorReverseCondition(false));
      element.category.fgp.gm3_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.fgp.gm3, key: 'element.category.fgp.gm3' , sport: 'NBA' }, this.getColorReverseCondition(false));
      element.category.fgp.gm5_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.fgp.gm5, key: 'element.category.fgp.gm5' , sport: 'NBA' }, this.getColorReverseCondition(false));
      element.category.fgp.season2020_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.fgp.season2020, key: 'element.category.fgp.season2020' , sport: 'NBA' }, this.getColorReverseCondition(false));

      element.category.threep.PrevGm_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.threep.PrevGm, key: 'element.category.threep.PrevGm' , sport: 'NBA' }, this.getColorReverseCondition(false));
      element.category.threep.gm3_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.threep.gm3, key: 'element.category.threep.gm3' , sport: 'NBA' }, this.getColorReverseCondition(false));
      element.category.threep.gm5_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.threep.gm5, key: 'element.category.threep.gm5' , sport: 'NBA' }, this.getColorReverseCondition(false));
      element.category.threep.season2020_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.threep.season2020, key: 'element.category.threep.season2020' , sport: 'NBA' }, this.getColorReverseCondition(false));

      element.category.threepa.PrevGm_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.threepa.PrevGm, key: 'element.category.threepa.PrevGm' , sport: 'NBA' }, this.getColorReverseCondition(false));
      element.category.threepa.gm3_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.threepa.gm3, key: 'element.category.threepa.gm3' , sport: 'NBA' }, this.getColorReverseCondition(false));
      element.category.threepa.gm5_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.threepa.gm5, key: 'element.category.threepa.gm5' , sport: 'NBA' }, this.getColorReverseCondition(false));
      element.category.threepa.season2020_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.threepa.season2020, key: 'element.category.threepa.season2020' , sport: 'NBA' }, this.getColorReverseCondition(false));

      element.category.threepp.PrevGm_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.threepp.PrevGm, key: 'element.category.threepp.PrevGm' , sport: 'NBA' }, this.getColorReverseCondition(false));
      element.category.threepp.gm3_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.threepp.gm3, key: 'element.category.threepp.gm3' , sport: 'NBA' }, this.getColorReverseCondition(false));
      element.category.threepp.gm5_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.threepp.gm5, key: 'element.category.threepp.gm5' , sport: 'NBA' }, this.getColorReverseCondition(false));
      element.category.threepp.season2020_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.threepp.season2020, key: 'element.category.threepp.season2020' , sport: 'NBA' }, this.getColorReverseCondition(false));

      element.category.ft.PrevGm_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.ft.PrevGm, key: 'element.category.ft.PrevGm' , sport: 'NBA' }, this.getColorReverseCondition(false));
      element.category.ft.gm3_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.ft.gm3, key: 'element.category.ft.gm3' , sport: 'NBA' }, this.getColorReverseCondition(false));
      element.category.ft.gm5_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.ft.gm5, key: 'element.category.ft.gm5' , sport: 'NBA' }, this.getColorReverseCondition(false));
      element.category.ft.season2020_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.ft.season2020, key: 'element.category.ft.season2020' , sport: 'NBA' }, this.getColorReverseCondition(false));

      element.category.fta.PrevGm_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.fta.PrevGm, key: 'element.category.fta.PrevGm' , sport: 'NBA' }, this.getColorReverseCondition(false));
      element.category.fta.gm3_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.fta.gm3, key: 'element.category.fta.gm3' , sport: 'NBA' }, this.getColorReverseCondition(false));
      element.category.fta.gm5_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.fta.gm5, key: 'element.category.fta.gm5' , sport: 'NBA' }, this.getColorReverseCondition(false));
      element.category.fta.season2020_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.fta.season2020, key: 'element.category.fta.season2020' , sport: 'NBA' }, this.getColorReverseCondition(false));

      element.category.ftp.PrevGm_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.ftp.PrevGm, key: 'element.category.ftp.PrevGm' , sport: 'NBA' }, this.getColorReverseCondition(false));
      element.category.ftp.gm3_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.ftp.gm3, key: 'element.category.ftp.gm3' , sport: 'NBA' }, this.getColorReverseCondition(false));
      element.category.ftp.gm5_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.ftp.gm5, key: 'element.category.ftp.gm5' , sport: 'NBA' }, this.getColorReverseCondition(false));
      element.category.ftp.season2020_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.ftp.season2020, key: 'element.category.ftp.season2020', sport: 'NBA'  }, this.getColorReverseCondition(false));

      element.category.trb.PrevGm_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.trb.PrevGm, key: 'element.category.trb.PrevGm' , sport: 'NBA' }, this.getColorReverseCondition(false));
      element.category.trb.gm3_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.trb.gm3, key: 'element.category.trb.gm3' , sport: 'NBA' }, this.getColorReverseCondition(false));
      element.category.trb.gm5_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.trb.gm5, key: 'element.category.trb.gm5' , sport: 'NBA' }, this.getColorReverseCondition(false));
      element.category.trb.season2020_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.trb.season2020, key: 'element.category.trb.season2020' , sport: 'NBA' }, this.getColorReverseCondition(false));

      element.category.org.PrevGm_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.org.PrevGm, key: 'element.category.org.PrevGm' , sport: 'NBA' }, this.getColorReverseCondition(false));
      element.category.org.gm3_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.org.gm3, key: 'element.category.org.gm3' , sport: 'NBA' }, this.getColorReverseCondition(false));
      element.category.org.gm5_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.org.gm5, key: 'element.category.org.gm5' , sport: 'NBA' }, this.getColorReverseCondition(false));
      element.category.org.season2020_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.org.season2020, key: 'element.category.org.season2020' , sport: 'NBA' }, this.getColorReverseCondition(false));

      element.category.drb.PrevGm_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.drb.PrevGm, key: 'element.category.drb.PrevGm' , sport: 'NBA' }, this.getColorReverseCondition(false));
      element.category.drb.gm3_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.drb.gm3, key: 'element.category.drb.gm3' , sport: 'NBA' }, this.getColorReverseCondition(false));
      element.category.drb.gm5_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.drb.gm5, key: 'element.category.drb.gm5' , sport: 'NBA' }, this.getColorReverseCondition(false));
      element.category.drb.season2020_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.drb.season2020, key: 'element.category.drb.season2020' , sport: 'NBA' }, this.getColorReverseCondition(false));

      element.category.ast.PrevGm_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.ast.PrevGm, key: 'element.category.ast.PrevGm' , sport: 'NBA' }, this.getColorReverseCondition(false));
      element.category.ast.gm3_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.ast.gm3, key: 'element.category.ast.gm3' , sport: 'NBA' }, this.getColorReverseCondition(false));
      element.category.ast.gm5_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.ast.gm5, key: 'element.category.ast.gm5' , sport: 'NBA' }, this.getColorReverseCondition(false));
      element.category.ast.season2020_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.ast.season2020, key: 'element.category.ast.season2020' , sport: 'NBA' }, this.getColorReverseCondition(false));

      element.category.stl.PrevGm_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.stl.PrevGm, key: 'element.category.stl.PrevGm' , sport: 'NBA' }, this.getColorReverseCondition(false));
      element.category.stl.gm3_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.stl.gm3, key: 'element.category.stl.gm3' , sport: 'NBA' }, this.getColorReverseCondition(false));
      element.category.stl.gm5_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.stl.gm5, key: 'element.category.stl.gm5' , sport: 'NBA' }, this.getColorReverseCondition(false));
      element.category.stl.season2020_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.stl.season2020, key: 'element.category.stl.season2020' , sport: 'NBA' }, this.getColorReverseCondition(false));

      element.category.blk.PrevGm_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.blk.PrevGm, key: 'element.category.blk.PrevGm' , sport: 'NBA' }, this.getColorReverseCondition(false));
      element.category.blk.gm3_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.blk.gm3, key: 'element.category.blk.gm3' , sport: 'NBA' }, this.getColorReverseCondition(false));
      element.category.blk.gm5_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.blk.gm5, key: 'element.category.blk.gm5' , sport: 'NBA' }, this.getColorReverseCondition(false));
      element.category.blk.season2020_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.blk.season2020, key: 'element.category.blk.season2020' , sport: 'NBA' }, this.getColorReverseCondition(false));

      element.category.tov.PrevGm_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.tov.PrevGm, key: 'element.category.tov.PrevGm' , sport: 'NBA' }, this.getColorReverseCondition(true));
      element.category.tov.gm3_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.tov.gm3, key: 'element.category.tov.gm3' , sport: 'NBA' }, this.getColorReverseCondition(true));
      element.category.tov.gm5_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.tov.gm5, key: 'element.category.tov.gm5' , sport: 'NBA' }, this.getColorReverseCondition(true));
      element.category.tov.season2020_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.tov.season2020, key: 'element.category.tov.season2020' , sport: 'NBA' }, this.getColorReverseCondition(true));

      element.category.pf.PrevGm_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.pf.PrevGm, key: 'element.category.pf.PrevGm' , sport: 'NBA' }, this.getColorReverseCondition(true));
      element.category.pf.gm3_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.pf.gm3, key: 'element.category.pf.gm3' , sport: 'NBA' }, this.getColorReverseCondition(true));
      element.category.pf.gm5_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.pf.gm5, key: 'element.category.pf.gm5' , sport: 'NBA' }, this.getColorReverseCondition(true));
      element.category.pf.season2020_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.pf.season2020, key: 'element.category.pf.season2020' , sport: 'NBA' }, this.getColorReverseCondition(true));

      element.points_team_rank_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.points_team_rank, key: 'element.points_team_rank' , sport: 'NBA' , type: 'rank'}, this.getColorReverseCondition(true, 'rank'));
      element.opp_points_team_rank_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.opp_points_team_rank, key: 'element.opp_points_team_rank', sport: 'NBA' , type: 'rank' }, this.getColorReverseCondition(false, 'rank'));

      element.pip_per_gm_team_rank_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.pip_per_gm_team_rank, key: 'element.pip_per_gm_team_rank', sport: 'NBA' , type: 'rank' }, this.getColorReverseCondition(true, 'rank'));
      element.opp_pip_per_gm_team_rank_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.opp_pip_per_gm_team_rank, key: 'element.opp_pip_per_gm_team_rank' , sport: 'NBA' , type: 'rank'}, this.getColorReverseCondition(false, 'rank'));

      element.fb_pt_per_gm_team_rank_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.fb_pt_per_gm_team_rank, key: 'element.fb_pt_per_gm_team_rank', sport: 'NBA' , type: 'rank' }, this.getColorReverseCondition(true, 'rank'));
      element.opp_fb_pt_per_gm_team_rank_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.opp_fb_pt_per_gm_team_rank, key: 'element.opp_fb_pt_per_gm_team_rank', sport: 'NBA' , type: 'rank' }, this.getColorReverseCondition(false, 'rank'));

      element.pt_of_pt_from_tpt_team_rank_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.pt_of_pt_from_tpt_team_rank, key: 'element.pt_of_pt_from_tpt_team_rank', sport: 'NBA' , type: 'rank' }, this.getColorReverseCondition(true, 'rank'));
      element.opp_pt_of_pt_from_tpt_team_rank_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.opp_pt_of_pt_from_tpt_team_rank, key: 'element.opp_pt_of_pt_from_tpt_team_rank', sport: 'NBA' , type: 'rank' }, this.getColorReverseCondition(false, 'rank'));

      element.pt_of_pt_from_tpthree_team_rank_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.pt_of_pt_from_tpthree_team_rank, key: 'element.pt_of_pt_from_tpthree_team_rank', sport: 'NBA' , type: 'rank' }, this.getColorReverseCondition(true, 'rank'));
      element.opp_pt_of_pt_from_tpthree_team_rank_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.opp_pt_of_pt_from_tpthree_team_rank, key: 'element.opp_pt_of_pt_from_tpthree_team_rank' , sport: 'NBA' , type: 'rank'}, this.getColorReverseCondition(false, 'rank'));

      element.thr_pt_md_per_gm_team_rank_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.thr_pt_md_per_gm_team_rank, key: 'element.thr_pt_md_per_gm_team_rank', sport: 'NBA' , type: 'rank' }, this.getColorReverseCondition(true, 'rank'));
      element.opp_thr_pt_md_per_gm_team_rank_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.opp_thr_pt_md_per_gm_team_rank, key: 'element.opp_thr_pt_md_per_gm_team_rank' , sport: 'NBA' , type: 'rank'}, this.getColorReverseCondition(false, 'rank'));

      element.tot_rb_per_gm_team_rank_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.tot_rb_per_gm_team_rank, key: 'element.tot_rb_per_gm_team_rank' , sport: 'NBA' , type: 'rank'}, this.getColorReverseCondition(true, 'rank'));
      element.opp_tot_rb_per_gm_team_rank_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.opp_tot_rb_per_gm_team_rank, key: 'element.opp_tot_rb_per_gm_team_rank' , sport: 'NBA' , type: 'rank'}, this.getColorReverseCondition(false, 'rank'));

      element.bk_per_gm_team_rank_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.bk_per_gm_team_rank, key: 'element.bk_per_gm_team_rank', sport: 'NBA' , type: 'rank' }, this.getColorReverseCondition(true, 'rank'));
      element.opp_bk_per_gm_team_rank_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.opp_bk_per_gm_team_rank, key: 'element.opp_bk_per_gm_team_rank', sport: 'NBA' , type: 'rank' }, this.getColorReverseCondition(false, 'rank'));

      element.sts_per_gm_team_rank_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.sts_per_gm_team_rank, key: 'element.sts_per_gm_team_rank' , sport: 'NBA' , type: 'rank'}, this.getColorReverseCondition(true, 'rank'));
      element.opp_sts_per_gm_team_rank_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.opp_sts_per_gm_team_rank, key: 'element.opp_sts_per_gm_team_rank' , sport: 'NBA' , type: 'rank'}, this.getColorReverseCondition(false, 'rank'));

      element.ast_per_gm_team_rank_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.ast_per_gm_team_rank, key: 'element.ast_per_gm_team_rank', sport: 'NBA' , type: 'rank'}, this.getColorReverseCondition(true, 'rank'));
      element.opp_ast_per_gm_team_rank_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.opp_ast_per_gm_team_rank, key: 'element.opp_ast_per_gm_team_rank', sport: 'NBA' , type: 'rank' }, this.getColorReverseCondition(false, 'rank'));

      element.tur_per_gm_team_rank_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.tur_per_gm_team_rank, key: 'element.tur_per_gm_team_rank', sport: 'NBA' , type: 'rank' }, this.getColorReverseCondition(true, 'rank'));
      element.opp_tur_per_gm_team_rank_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.opp_tur_per_gm_team_rank, key: 'element.opp_tur_per_gm_team_rank', sport: 'NBA' , type: 'rank' }, this.getColorReverseCondition(false, 'rank'));

      element.pers_fl_per_gm_team_rank_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.pers_fl_per_gm_team_rank, key: 'element.pers_fl_per_gm_team_rank', sport: 'NBA' , type: 'rank' }, this.getColorReverseCondition(true, 'rank'));
      element.opp_pers_fl_per_gm_team_rank_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.opp_pers_fl_per_gm_team_rank, key: 'element.opp_pers_fl_per_gm_team_rank' , sport: 'NBA' , type: 'rank'}, this.getColorReverseCondition(false, 'rank'));
    });
  }


  setMLBColor(item) {
    item.data.listPlayer.forEach(element => {
      element.category.vegas_odds.odds_implied_team_total_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.vegas_odds.odds_implied_team_total, key: 'element.category.vegas_odds.odds_implied_team_total' , sport: 'MLB', player_type : this.selectedFilters.player_type}, this.getColorReverseCondition(false));
      element.category.vegas_odds.odds_spread_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.vegas_odds.odds_spread, key: 'element.category.vegas_odds.odds_spread' , sport: 'MLB', player_type : this.selectedFilters.player_type}, this.getColorReverseCondition(true));
      element.category.vegas_odds.odds_ou_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.vegas_odds.odds_ou, key: 'element.category.vegas_odds.odds_ou' , sport: 'MLB', player_type : this.selectedFilters.player_type}, this.getColorReverseCondition(false));

      if (element.category.fantasy_points) {
        element.category.fantasy_points.PrevGm_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.fantasy_points.PrevGm, key: 'element.category.fantasy_points.PrevGm', sport: 'MLB', player_type : this.selectedFilters.player_type }, this.getColorReverseCondition(false));
        element.category.fantasy_points.gm3_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.fantasy_points.gm3, key: 'element.category.fantasy_points.gm3' , sport: 'MLB', player_type : this.selectedFilters.player_type}, this.getColorReverseCondition(false));
        element.category.fantasy_points.gm5_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.fantasy_points.gm5, key: 'element.category.fantasy_points.gm5' , sport: 'MLB', player_type : this.selectedFilters.player_type}, this.getColorReverseCondition(false));
        element.category.fantasy_points.season2020_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.fantasy_points.season2020, key: 'element.category.fantasy_points.season2020' , sport: 'MLB', player_type : this.selectedFilters.player_type}, this.getColorReverseCondition(false));
      }


      if (element.category.fantasy_value) {
        element.category.fantasy_value.PrevGm_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.fantasy_value.PrevGm, key: 'element.category.fantasy_value.PrevGm' , sport: 'MLB', player_type : this.selectedFilters.player_type}, this.getColorReverseCondition(false));
        element.category.fantasy_value.gm3_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.fantasy_value.gm3, key: 'element.category.fantasy_value.gm3' , sport: 'MLB', player_type : this.selectedFilters.player_type}, this.getColorReverseCondition(false));
        element.category.fantasy_value.gm5_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.fantasy_value.gm5, key: 'element.category.fantasy_value.gm5' , sport: 'MLB', player_type : this.selectedFilters.player_type}, this.getColorReverseCondition(false));
        element.category.fantasy_value.season2020_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.fantasy_value.season2020, key: 'element.category.fantasy_value.season2020' , sport: 'MLB', player_type : this.selectedFilters.player_type}, this.getColorReverseCondition(false));
      }

      element.category.high_score.gm3_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.high_score.gm3, key: 'element.category.high_score.gm3' , sport: 'MLB', player_type : this.selectedFilters.player_type}, this.getColorReverseCondition(false));
      element.category.high_score.gm5_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.high_score.gm5, key: 'element.category.high_score.gm5' , sport: 'MLB', player_type : this.selectedFilters.player_type}, this.getColorReverseCondition(false));
      element.category.high_score.season2020_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.high_score.season2020, key: 'element.category.high_score.season2020' , sport: 'MLB', player_type : this.selectedFilters.player_type}, this.getColorReverseCondition(false));

      element.category.low_score.gm3_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.low_score.gm3, key: 'element.category.low_score.gm3' , sport: 'MLB', player_type : this.selectedFilters.player_type}, this.getColorReverseCondition(false));
      element.category.low_score.gm5_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.low_score.gm5, key: 'element.category.low_score.gm5' , sport: 'MLB', player_type : this.selectedFilters.player_type}, this.getColorReverseCondition(false));
      element.category.low_score.season2020_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.low_score.season2020, key: 'element.category.low_score.season2020', sport: 'MLB', player_type : this.selectedFilters.player_type }, this.getColorReverseCondition(false));

      if ( this.selectedFilters.player_type == 'batting') {
        element.category.avg.gm3_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.avg.gm3, key: 'element.category.avg.gm3' , sport: 'MLB', player_type : this.selectedFilters.player_type}, this.getColorReverseCondition(false));
        element.category.avg.gm5_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.avg.gm5, key: 'element.category.avg.gm5' , sport: 'MLB', player_type : this.selectedFilters.player_type}, this.getColorReverseCondition(false));
        element.category.avg.season2020_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.avg.season2020, key: 'element.category.avg.season2020', sport: 'MLB' , player_type : this.selectedFilters.player_type}, this.getColorReverseCondition(false));


        element.category.obp.gm3_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.obp.gm3, key: 'element.category.obp.gm3' , sport: 'MLB', player_type : this.selectedFilters.player_type}, this.getColorReverseCondition(false));
        element.category.obp.gm5_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.obp.gm5, key: 'element.category.obp.gm5' , sport: 'MLB', player_type : this.selectedFilters.player_type}, this.getColorReverseCondition(false));
        element.category.obp.season2020_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.obp.season2020, key: 'element.category.obp.season2020', sport: 'MLB', player_type : this.selectedFilters.player_type }, this.getColorReverseCondition(false));



        element.category.slg.gm3_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.slg.gm3, key: 'element.category.slg.gm3' , sport: 'MLB', player_type : this.selectedFilters.player_type}, this.getColorReverseCondition(false));
        element.category.slg.gm5_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.slg.gm5, key: 'element.category.slg.gm5' , sport: 'MLB', player_type : this.selectedFilters.player_type}, this.getColorReverseCondition(false));
        element.category.slg.season2020_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.slg.season2020, key: 'element.category.slg.season2020', sport: 'MLB' , player_type : this.selectedFilters.player_type}, this.getColorReverseCondition(false));


        element.category.ops.gm3_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.ops.gm3, key: 'element.category.ops.gm3' , sport: 'MLB', player_type : this.selectedFilters.player_type}, this.getColorReverseCondition(false));
        element.category.ops.gm5_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.ops.gm5, key: 'element.category.ops.gm5' , sport: 'MLB', player_type : this.selectedFilters.player_type}, this.getColorReverseCondition(false));
        element.category.ops.season2020_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.ops.season2020, key: 'element.category.ops.season2020', sport: 'MLB', player_type : this.selectedFilters.player_type }, this.getColorReverseCondition(false));

        /*element.category.woba.gm3_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.woba.gm3, key: 'element.category.woba.gm3' , sport: 'MLB', player_type : this.selectedFilters.player_type}, this.getColorReverseCondition(false));
        element.category.woba.gm5_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.woba.gm5, key: 'element.category.woba.gm5' , sport: 'MLB', player_type : this.selectedFilters.player_type}, this.getColorReverseCondition(false));
        element.category.woba.season2020_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.woba.season2020, key: 'element.category.woba.season2020', sport: 'MLB', player_type : this.selectedFilters.player_type }, this.getColorReverseCondition(false));
*/
        element.category.iso.gm3_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.iso.gm3, key: 'element.category.iso.gm3' , sport: 'MLB', player_type : this.selectedFilters.player_type}, this.getColorReverseCondition(false));
        element.category.iso.gm5_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.iso.gm5, key: 'element.category.iso.gm5' , sport: 'MLB', player_type : this.selectedFilters.player_type}, this.getColorReverseCondition(false));
        element.category.iso.season2020_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.iso.season2020, key: 'element.category.iso.season2020', sport: 'MLB' , player_type : this.selectedFilters.player_type}, this.getColorReverseCondition(false));



        element.category.babip.gm3_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.babip.gm3, key: 'element.category.babip.gm3' , sport: 'MLB', player_type : this.selectedFilters.player_type}, this.getColorReverseCondition(false));
        element.category.babip.gm5_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.babip.gm5, key: 'element.category.babip.gm5' , sport: 'MLB', player_type : this.selectedFilters.player_type}, this.getColorReverseCondition(false));
        element.category.babip.season2020_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.babip.season2020, key: 'element.category.babip.season2020', sport: 'MLB', player_type : this.selectedFilters.player_type }, this.getColorReverseCondition(false));



        element.category.ct.gm3_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.ct.gm3, key: 'element.category.ct.gm3' , sport: 'MLB', player_type : this.selectedFilters.player_type}, this.getColorReverseCondition(false));
        element.category.ct.gm5_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.ct.gm5, key: 'element.category.ct.gm5' , sport: 'MLB', player_type : this.selectedFilters.player_type}, this.getColorReverseCondition(false));
        element.category.ct.season2020_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.ct.season2020, key: 'element.category.ct.season2020', sport: 'MLB' , player_type : this.selectedFilters.player_type}, this.getColorReverseCondition(false));



        element.category.rc.gm3_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.rc.gm3, key: 'element.category.rc.gm3' , sport: 'MLB', type: 'rank', player_type : this.selectedFilters.player_type}, this.getColorReverseCondition(false,'rank'));
        element.category.rc.gm5_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.rc.gm5, key: 'element.category.rc.gm5' , sport: 'MLB', type: 'rank', player_type : this.selectedFilters.player_type}, this.getColorReverseCondition(false,'rank'));
        element.category.rc.season2020_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.rc.season2020, key: 'element.category.rc.season2020', sport: 'MLB', type: 'rank', player_type : this.selectedFilters.player_type }, this.getColorReverseCondition(false,'rank'));



        element.category.bbk.gm3_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.bbk.gm3, key: 'element.category.bbk.gm3' , sport: 'MLB', player_type : this.selectedFilters.player_type}, this.getColorReverseCondition(false));
        element.category.bbk.gm5_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.bbk.gm5, key: 'element.category.bbk.gm5' , sport: 'MLB', player_type : this.selectedFilters.player_type}, this.getColorReverseCondition(false));
        element.category.bbk.season2020_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.bbk.season2020, key: 'element.category.bbk.season2020', sport: 'MLB', player_type : this.selectedFilters.player_type }, this.getColorReverseCondition(false));



        element.category.walk.gm3_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.walk.gm3, key: 'element.category.walk.gm3' , sport: 'MLB', player_type : this.selectedFilters.player_type}, this.getColorReverseCondition(false));
        element.category.walk.gm5_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.walk.gm5, key: 'element.category.walk.gm5' , sport: 'MLB', player_type : this.selectedFilters.player_type}, this.getColorReverseCondition(false));
        element.category.walk.season2020_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.walk.season2020, key: 'element.category.walk.season2020', sport: 'MLB', player_type : this.selectedFilters.player_type }, this.getColorReverseCondition(false));

      }



      /*pitching category*/
      if ( this.selectedFilters.player_type == 'pitching'){

        element.category.ip.gm3_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.ip.gm3, key: 'element.category.ip.gm3' , sport: 'MLB', player_type : this.selectedFilters.player_type}, this.getColorReverseCondition(false));
        element.category.ip.gm5_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.ip.gm5, key: 'element.category.ip.gm5' , sport: 'MLB', player_type : this.selectedFilters.player_type}, this.getColorReverseCondition(false));
        element.category.ip.season2020_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.ip.season2020, key: 'element.category.ip.season2020', sport: 'MLB' , player_type : this.selectedFilters.player_type}, this.getColorReverseCondition(false));

        element.category.so.gm3_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.so.gm3, key: 'element.category.so.gm3' , sport: 'MLB', player_type : this.selectedFilters.player_type}, this.getColorReverseCondition(false));
        element.category.so.gm5_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.so.gm5, key: 'element.category.so.gm5' , sport: 'MLB', player_type : this.selectedFilters.player_type}, this.getColorReverseCondition(false));
        element.category.so.season2020_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.so.season2020, key: 'element.category.so.season2020', sport: 'MLB' , player_type : this.selectedFilters.player_type}, this.getColorReverseCondition(false));

        element.category.era.gm3_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.era.gm3, key: 'element.category.era.gm3' , sport: 'MLB', player_type : this.selectedFilters.player_type}, this.getColorReverseCondition(false));
        element.category.era.gm5_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.era.gm5, key: 'element.category.era.gm5' , sport: 'MLB', player_type : this.selectedFilters.player_type}, this.getColorReverseCondition(false));
        element.category.era.season2020_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.era.season2020, key: 'element.category.era.season2020', sport: 'MLB' , player_type : this.selectedFilters.player_type}, this.getColorReverseCondition(false));

        element.category.whip.gm3_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.whip.gm3, key: 'element.category.whip.gm3' , sport: 'MLB', player_type : this.selectedFilters.player_type}, this.getColorReverseCondition(false));
        element.category.whip.gm5_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.whip.gm5, key: 'element.category.whip.gm5' , sport: 'MLB', player_type : this.selectedFilters.player_type}, this.getColorReverseCondition(false));
        element.category.whip.season2020_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.whip.season2020, key: 'element.category.whip.season2020', sport: 'MLB' , player_type : this.selectedFilters.player_type}, this.getColorReverseCondition(false));

        element.category.fip.gm3_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.fip.gm3, key: 'element.category.fip.gm3' , sport: 'MLB', player_type : this.selectedFilters.player_type}, this.getColorReverseCondition(false));
        element.category.fip.gm5_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.fip.gm5, key: 'element.category.fip.gm5' , sport: 'MLB', player_type : this.selectedFilters.player_type}, this.getColorReverseCondition(false));
        element.category.fip.season2020_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.fip.season2020, key: 'element.category.fip.season2020', sport: 'MLB' , player_type : this.selectedFilters.player_type}, this.getColorReverseCondition(false));

        element.category.k9.gm3_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.k9.gm3, key: 'element.category.k9.gm3' , sport: 'MLB', player_type : this.selectedFilters.player_type}, this.getColorReverseCondition(false));
        element.category.k9.gm5_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.k9.gm5, key: 'element.category.k9.gm5' , sport: 'MLB', player_type : this.selectedFilters.player_type}, this.getColorReverseCondition(false));
        element.category.k9.season2020_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.k9.season2020, key: 'element.category.k9.season2020', sport: 'MLB' , player_type : this.selectedFilters.player_type}, this.getColorReverseCondition(false));

        element.category.bb9.gm3_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.bb9.gm3, key: 'element.category.bb9.gm3' , sport: 'MLB', player_type : this.selectedFilters.player_type}, this.getColorReverseCondition(false));
        element.category.bb9.gm5_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.bb9.gm5, key: 'element.category.bb9.gm5' , sport: 'MLB', player_type : this.selectedFilters.player_type}, this.getColorReverseCondition(false));
        element.category.bb9.season2020_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.bb9.season2020, key: 'element.category.bb9.season2020', sport: 'MLB', player_type : this.selectedFilters.player_type }, this.getColorReverseCondition(false));

        element.category.kbb.gm3_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.kbb.gm3, key: 'element.category.kbb.gm3' , sport: 'MLB', player_type : this.selectedFilters.player_type}, this.getColorReverseCondition(false));
        element.category.kbb.gm5_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.kbb.gm5, key: 'element.category.kbb.gm5' , sport: 'MLB', player_type : this.selectedFilters.player_type}, this.getColorReverseCondition(false));
        element.category.kbb.season2020_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.kbb.season2020, key: 'element.category.kbb.season2020', sport: 'MLB' , player_type : this.selectedFilters.player_type}, this.getColorReverseCondition(false));

        element.category.hr9.gm3_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.hr9.gm3, key: 'element.category.hr9.gm3' , sport: 'MLB', player_type : this.selectedFilters.player_type}, this.getColorReverseCondition(false));
        element.category.hr9.gm5_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.hr9.gm5, key: 'element.category.hr9.gm5' , sport: 'MLB', player_type : this.selectedFilters.player_type}, this.getColorReverseCondition(false));
        element.category.hr9.season2020_colorCode = this.sharedService.getColorCode(item.data.listPlayer, { value: element.category.hr9.season2020, key: 'element.category.hr9.season2020', sport: 'MLB' , player_type : this.selectedFilters.player_type}, this.getColorReverseCondition(false));

      }
    });
  }

  setDatatable() {
    $(document).ready(() => {
      $('#managerTable').DataTable({
        // bPaginate: false,
        // bLengthChange: true,
        // bFilter: false,
        // bInfo: false,
        // bAutoWidth: true,
        // ordering: false,
        destroy: true,
        scrollY: 300,
        scrollX: true,
        scrollCollapse: true,
        paging: false,
        fixedColumns: true,
        bFilter: false,
      });
      $('#managerTable').tableDnD({
        onDragStop: (table: HTMLElement, row) => {
          const players = [];
          const trs = table.querySelectorAll('tbody tr');
          trs.forEach((data, index) => {
            players.push({
              manager_player_id: data.getAttribute('manager_player_id'),
              sort_order: (index + 1).toString()
            });
          });
          this.dragCompleted(players);
        }
      });
    });
  }

  dragCompleted(players) {
    // const tmpData = new URLSearchParams();
    // tmpData.set('user_id', this.loginUserDetails.user_id);
    // tmpData.set('players', players);
    // tmpData.set('accessToken', this.loginUserDetails.accessToken);
    const tmpData = {
      user_id: this.loginUserDetails.user_id,
      players
    };

    this.api.changeOrderOfPlayerManager(tmpData).subscribe(item => {
      this.SpinnerService.hide();
      if (item && item.code == 100) {
        this.defualtFilters();
      }
    });
  }

  gameseasonfiler() {
    this.PlayerList();
  }

  categoryFilterChange(value) {
    this.selectedFilters.category = value;
    this.PlayerList();
  }


  onRemovePlayer(item) {
    Swal.fire({
      title: 'Are you sure want to Remove?',
      text: '',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No'
    }).then((result) => {
      if (result.value) {
        this.RemovePlayerApi(item);
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        // console.log('Cancel Clicked');
      }
    });
  }

  RemovePlayerApi(item) {
    const ids = {
      user_id: (this.loginUserDetails && this.loginUserDetails.user_id) ? this.loginUserDetails.user_id : '',
      player_id: item.player_id
      //
    };
    this.SpinnerService.show();
    this.api.removePlayerFormManager(ids).subscribe(data => {
      this.SpinnerService.hide();
      if (data && data.code == 100) {
        this.sharedService.updateManagerPlayerCount(data.managePlayerCount);
        this.PlayerList();
        // console.log('Player Removed successfully');
      } else {
        // console.log('Remove Player From Manager Api :' + data.message);
      }
    }, (err) => {
      this.SpinnerService.hide();
      // console.log('something went wrong');
    });
  }

  getPlatformandSport(data) {
    // console.log(data);
    this.navService.onPlatformandSportChange('Changed');
    this.selectedFilters.platformId = data.platformId;
    this.selectedFilters.sportId = data.sportId;

    this.selectedFilters.Position = '';
    this.selectedFilters.Teams = '';
    this.selectedFilters.excludehighlow = 0;
    this.selectedFilters.ha = '';
    this.selectedFilters.typedisplay = 1;
    this.selectedFilters.salaryRange = '0, 100000.00';

    if(data.sportId != 3)
      this.selectedFilters.player_type = "pitching";

    this.managerPlayerList = [];
    this.defualtFilters();
  }

  getGameandSlate(data) {
    console.log(data);
    this.dropdownChanged =true;
    this.selectedFilters.gameStyle = data.gameStyle;
    this.selectedFilters.slate = data.slate;
    this.boardPlayerList = [];
    this.resetFilters = null;
    this.PlayerList();
    this.resetFilters = pageFilters.chalkBoard;
  }

  getSideBarFilteredData(data) {
    // console.log(data);
    this.selectedFilters.Position = data.Position;
    this.selectedFilters.Teams = data.Teams;
    // this.selectedFilters.categoryName = data.categoryName;
    this.selectedFilters.excludehighlow = data.excludehighlow;
    this.selectedFilters.ha = data.ha;
    this.selectedFilters.player_type = data.player_type;
    // this.selectedFilters.playerId = data.playerId;
    this.selectedFilters.typedisplay = data.typedisplay;
    this.selectedFilters.salaryRange = data.salaryRange;
    this.PlayerList();
  }

  getFilteredData(data) {
    // console.log(data);
    this.selectedFilters = data;
    if (this.selectedFilters.defualtPlatformSportChange == true) {
      this.defualtFilters();
    } else {
      this.PlayerList();
    }

  }

  ngOnDestroy() {
    const currentUrl = this.route.url;
    this.navService.changeNavHeaderActive(currentUrl);
  }


  onLast5() {
    const currentUrl = this.route.url;
    this.navService.changeNavHeaderActive(currentUrl);
    this.route.navigate(['/Last5']);
  }

  onTrends() {
    const currentUrl = this.route.url;
    this.navService.changeNavHeaderActive(currentUrl);
    this.route.navigate(['/Trends']);
  }

  openPlayerModalDialog(item) {
    this.defualtPopupTab = 'Trends';
    // console.log(item);
    this.PopupLast5Position = '';
    this.popupLast5SalaryRange = '0, 100000.00';
    this.popupLast5SomeRange = [0, 100000.00];
    this.popUpLast5playerList = [];
    this.playerStatus = item.status;
    this.selectedFilters.slate = item.slates_id;
    this.selectedPlayerForPopup = item;
    this.selectedPlayerForPopup.ha = this.selectedPlayerForPopup.ha.trim();
    this.selectedPlayerForPopup.team_symbol = (this.selectedPlayerForPopup.ha == 'h' || this.selectedPlayerForPopup.ha == 'H') ? ' vs. ' : ' @ ';
    this.getPlayerGameLog();
    this.onTrendsPopup();
  }

  watchPlayer(value) {
    // console.log(this.playerStatus);
    if (this.playerStatus != '') {
      if (this.loginUserDetails.isLogin) {
        const item = {
          user_id: this.loginUserDetails.user_id,
          player_id: this.selectedPlayerForPopup.player_id,
          status: value
        };
        this.SpinnerService.show();
        this.api.playerWatch(item).subscribe(data => {
          this.SpinnerService.hide();
          if (data && data.code == 100) {
            this.toastr.success('Player status updated ', 'Success');
            this.PlayerList();
          } else {
            // console.log('Watch Player Api :' + data.message);
          }
        }, (err) => {
          this.SpinnerService.hide();
          // console.log('something went wrong');
        });
      } else {
        alert('You need to login compulsory');
      }
    }

  }

  onSeeMoreLast5() {
    const currentUrl = this.route.url;
    this.navService.changeNavHeaderActive(currentUrl);
    this.route.navigate(['/Last5']);
  }

  onSeeMoreTrend() {
    const currentUrl = this.route.url;
    this.navService.changeNavHeaderActive(currentUrl);
    this.route.navigate(['/Trends']);
  }


  onPopupPosition() {
    this.onLast5Popup();
  }

  onLast5Popup() {

    const lastPlayersFiltersData = {
      user_id: (this.loginUserDetails && this.loginUserDetails.user_id) ? this.loginUserDetails.user_id : '',
      sport_id: this.selectedFilters.sportId,
      platform_id: this.selectedFilters.platformId,
      slates_id: this.selectedFilters.slate.toString(),
      position: this.PopupLast5Position,
      salary_range: this.popupLast5SalaryRange,
      player_id: this.selectedPlayerForPopup.player_id,
      category_name: 'fantasy_points' // this is extra value for getting api response
    };
    this.SpinnerService.show();
    this.api.last5PlayerList(lastPlayersFiltersData).subscribe(item => {
      this.SpinnerService.hide();
      if (item && item.code == 100) {

        this.popUpLast5playerList = item.data.listPlayer;
      } else {
        this.popUpLast5playerList = [];
      }
    }, (err) => {
      this.SpinnerService.hide();
      this.popUpLast5playerList = [];
      // console.log('something went wrong');
    });
  }

  onPopupTabs(type, index) {
    this.defualtPopupTab = type;
    if (index == 1) {
      this.getPlayerGameLog();
      this.onTrendsPopup();
    } else if (index == 2) {
      this.PopupLast5Position = '';
      this.popupLast5SalaryRange = '0, 100000.00';
      this.popupLast5SomeRange = [0, 100000.00];
      this.popUpLast5playerList = [];
      this.onLast5Popup();
    } else if (index == 3) {
      this.onTrendsPopup();
    }
  }

  getPlayerGameLog() {
    const tmpData = {
      user_id: (this.loginUserDetails && this.loginUserDetails.user_id) ? this.loginUserDetails.user_id : '',
      platform_id: this.selectedFilters.platformId,
      sport_id: this.selectedFilters.sportId,
      player_id: String(this.selectedPlayerForPopup.player_id),
      player_type:this.selectedFilters.player_type,
    };
    this.SpinnerService.show();
    this.playerGameLogList = [];
    this.api.getPlayerGameLog(tmpData).subscribe(item => {
      this.SpinnerService.hide();
      if (item && item.code == 100) {
        if (item.data && item.data.gameLog) {
          this.playerGameLogList = item.data.gameLog;
        }
      }
    });
  }

  // onLast5TabPopup(){
  //   this.PopupLast5Position = "";
  //   this.popupLast5SalaryRange = '0, 100000.00';
  //   this.popupLast5SomeRange = [0, 100000.00];
  //   this.popUpLast5playerList = [];
  //   this.onLast5Popup();
  // }

  onPopupRangeChanged(query) {
    this.minValue = query[0];
    this.maxValue = query[1];

    this.popupLast5TxtQueryChanged.next(query);
  }

  minMaxValueChange(isMinChange) {
    if (isMinChange) {
      if (this.minValue < 0 || this.minValue > this.maxValue) {
        this.minValue = 0;
      }
    } else {
      if (this.maxValue > 100000.00 || this.maxValue < this.minValue) {
        this.maxValue = 100000.00;
      }
    }
    const tmp = [];
    tmp[0] = this.minValue;
    tmp[1] = this.maxValue;
    this.popupLast5SomeRange = tmp;
    this.onPopupRangeChanged(tmp);
  }

  onTrendsPopup() {
    const players = {
      players: [
        { player_id: this.selectedPlayerForPopup.player_id, opp: '', ha: ''}]
    };
    const trendsPlayersFiltersData = {
      sport_id: this.selectedFilters.sportId,
      platform_id: this.selectedFilters.platformId,
      category_name: this.selectedFilters.categoryName,
      record_type: 'game',
      limit: this.selectedFilters.limit,
      players: JSON.stringify(players),
      player_type: this.selectedFilters.player_type,
    };
    this.SpinnerService.show();
    this.api.trendsPlayerList(trendsPlayersFiltersData).subscribe(item => {
      this.SpinnerService.hide();
      if (item && item.code == 100) {
        this.popupTrendPlayerList = item.data;
      } else {
        this.popupTrendPlayerList = { data: [], labelList: [] };
      }
      this.graphView();
    }, (err) => {
      this.SpinnerService.hide();
      this.popupTrendPlayerList = { data: [], labelList: [] };
      this.graphView();
      // console.log('something went wrong');
    });
  }

  graphView() {
    this.popupTrendfinalGraphData = {
      labels: [],
      datasets: []
    };
    if (this.popupTrendPlayerList && this.popupTrendPlayerList.labelList.length > 0) {
      let count = 1;
      this.popupTrendPlayerList.data.forEach(element => {
        let tempvalue = {};
        if (element != null) {
          let lineColor = 'rgba(255,126,0)';
          if (count == 2) {
            lineColor = 'rgba(0,100,246)';
          } else if (count == 3) {
            lineColor = 'rgba(209,0,222)';
          } else if (count == 4) {
            lineColor = 'rgba(51,204,102)';
          } else if (count == 5) {
            lineColor = 'rgba(255,0,51)';
          }

          tempvalue = {
            label: element.player_name,
            opp_title: element.opp_title,
            category: element.category,
            dates: element.dates,
            fill: false,
            lineTension: '0',
            borderWidth: '2',
            backgroundColor: lineColor,
            borderColor: lineColor,
            pointBackgroundColor: lineColor,
            pointBorderColor: 'rgba(0,0,0)',
            pointBorderWidth: '1',
            data: element.points
          };
          count++;
        } else {
          tempvalue = null;
          this.popupTrendfinalGraphData.labels.push(null);
        }

        this.popupTrendfinalGraphData.labels = this.popupTrendPlayerList.labelList;
        // this.popupTrendfinalGraphData.labels = element.dates;
        this.popupTrendfinalGraphData.datasets.push(tempvalue);
      });
    } else {
      this.popupTrendfinalGraphData = null;
    }

    if (this.popupTrendMyChart) {
      this.popupTrendMyChart.chart.clear();
      this.popupTrendMyChart.chart.destroy();
      this.popupTrendMyChart.destroy();
    }

    if (this.popupTrendfinalGraphData && this.popupTrendfinalGraphData.datasets) {
      this.popupTrendfinalGraphData.datasets = this.popupTrendfinalGraphData.datasets.filter((el) => {
        return el != null;
      });
    }

    if (this.popupTrendfinalGraphData && this.popupTrendfinalGraphData.labels) {
      this.popupTrendfinalGraphData.labels = this.popupTrendfinalGraphData.labels.filter((el) => {
        return el != null;
      });
    }

    const ctx = document.getElementById('myChart');
    this.popupTrendMyChart = new Chart(ctx, {
      type: 'line',
      data: this.popupTrendfinalGraphData,
      options: {
        responsive: true,
        title: {
          display: false
        },
        tooltips: {
          hideDelay: 0,
          callbacks: {
            title: function(tooltipItem, data){
              return data.datasets[tooltipItem[0].datasetIndex].label;
            },
            label: function(tooltipItem, data) {
              let label = [];
              label.push('Date : ' + data.datasets[tooltipItem.datasetIndex].dates[tooltipItem.index]);
              label.push('Opponent : ' + data.datasets[tooltipItem.datasetIndex].opp_titles[tooltipItem.index]);
              label.push(data.datasets[tooltipItem.datasetIndex].category + ' : ' + Math.round(tooltipItem.yLabel * 100) / 100);

              return label;
            }
          }
        },
        hover: {
          mode: 'nearest',
          intersect: true
        },
        scales: {
          xAxes: [{
            display: true,
            scaleLabel: {
              display: false,
              labelString: 'Games'
            }
          }],
          yAxes: [{
            display: true,
            scaleLabel: {
              display: false,
              labelString: 'Usage %'
            }
          }]
        }
      }
    });
    this.popupTrendMyChart.render();
  }

  gmColor(value, sportId = 1 , categoryName = 'fantasy_points') {
    return this.sharedService.getLast5ColorCode(value, sportId, categoryName);
  }

  // No method Found
  changeCategory:any;

  addRemovePlayer(item){

  }
}
